module.exports = __webpack_public_path__ + "static/media/gabriel_lencina.4f1925f9.jpg";